import { colors } from "#app/theme/v1/colors";
import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { PartName } from "#modules/similarPart/view/PartName";
import { Flex } from "#shared/view/components/Flex";
import { Stack } from "#shared/view/components/Stack";
import { ThumbnailOverlay } from "#shared/view/components/Thumbnails/ThumbnailOverlay";

import { QuoteRequestLineChips } from "../QuoteRequestLine/QuoteRequestLineChips";
import { PartHeaderSkeleton } from "./PartHeadertSkeleton";

type Props = {
  quoteRequestLine: QuoteRequestLineDto;
  hasChildren: boolean;
  isConsumable: boolean;
  fontSize: number;
  thumbnailSize: { width: number; height: number };
  part: PartDto | undefined;
  showWeight?: boolean;
  showMaterial?: boolean;
  disablePartTypeChip?: boolean;
  overlayOpened?: boolean;
  onOverlayClose?: () => void;
  overlayDefaultTab?: string | null;
};

export const PartHeader = ({
  quoteRequestLine,
  hasChildren,
  isConsumable,
  fontSize,
  thumbnailSize,
  part,
  showWeight = false,
  showMaterial = true,
  disablePartTypeChip = false,
  overlayOpened,
  onOverlayClose,
  overlayDefaultTab,
}: Props) => {
  if (!part) {
    return <PartHeaderSkeleton />;
  }

  return (
    <Flex gap="xs" align={"flex-start"} miw={350}>
      <ThumbnailOverlay
        part={part}
        size={thumbnailSize}
        quoteRequestLineId={quoteRequestLine.id}
        opened={overlayOpened}
        onClose={onOverlayClose}
        defaultTab={overlayDefaultTab}
      />

      <Stack gap={0}>
        <PartName
          partName={part.name}
          fz={fontSize}
          fw={600}
          lineClamp={1}
          c={colors.gray[9]}
          partId={part.id}
          editable
        />

        <QuoteRequestLineChips
          part={part}
          quoteRequestLine={quoteRequestLine}
          hasChildren={hasChildren}
          isConsumable={isConsumable}
          showWeight={showWeight}
          showMaterial={showMaterial}
          disablePartTypeChip={disablePartTypeChip}
        />
      </Stack>
    </Flex>
  );
};
